import React from 'react';
import {IconButton} from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import LightModeIcon from '@mui/icons-material/WbSunny';
import {themeDarkPoppins} from 'providers/themeDarkPoppins';
import {themePoppins} from 'providers/themePoppins';
import {themeContext} from 'common/context/ThemeContext';

export const ThemeToggler = () => {
   const [theme, setTheme] = React.useContext(themeContext);
   const isDark = theme === themeDarkPoppins;
   return (
      <IconButton
         sx={{ml: 1}}
         onClick={() => setTheme(isDark ? themePoppins : themeDarkPoppins)}
         color={isDark ? 'inherit' : 'primary'}
      >
         {theme.palette.mode === 'dark' ? <LightModeIcon /> : <Brightness4Icon />}
      </IconButton>
   );
};
